import { Box, Card, Typography, Button, Stack, alpha } from '@mui/material';
import { SupportAgent, Schedule, Headset } from '@mui/icons-material';
import { themeColors } from '../../../theme/theme';
import { useTranslation } from '../../../kit/useTranslation';

export default function NeedHelpSection({ onContact, isDesktop = false }) {
  const { t } = useTranslation();
  if (isDesktop) {
    return (
      <Box sx={{ textAlign: 'center' }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: 3,
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
            boxShadow: '0 8px 24px rgba(99, 102, 241, 0.25)',
          }}
        >
          <Headset sx={{ fontSize: 32, color: '#fff' }} />
        </Box>
        <Typography sx={{ fontWeight: 700, fontSize: '1.1rem', color: '#1e293b', mb: 1 }}>
          {t('support.stillNeedHelp')}
        </Typography>
        <Typography sx={{ fontSize: '0.85rem', color: '#64748b', mb: 2 }}>
          {t('support.supportAvailable')}
        </Typography>
        <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              px: 1.5,
              py: 0.5,
              bgcolor: alpha('#10b981', 0.1),
              borderRadius: 2,
            }}
          >
            <Schedule sx={{ fontSize: 14, color: '#10b981' }} />
            <Typography sx={{ fontSize: '0.7rem', fontWeight: 600, color: '#10b981' }}>
              {t('support.support247')}
            </Typography>
          </Box>
        </Stack>
        <Button
          fullWidth
          variant="contained"
          startIcon={<SupportAgent />}
          onClick={() => onContact('chat')}
          sx={{
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 2,
            py: 1.25,
            boxShadow: '0 4px 14px rgba(99, 102, 241, 0.3)',
            '&:hover': {
              background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
            },
          }}
        >
          {t('support.startChat')}
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ px: 2, mt: 4, mb: 2 }}>
      <Card
        elevation={0}
        sx={{
          borderRadius: 3,
          background:
            'linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(139, 92, 246, 0.08) 100%)',
          border: '1px solid rgba(99, 102, 241, 0.2)',
          textAlign: 'center',
          py: 3,
          px: 2,
        }}
      >
        <Typography variant="h6" fontWeight={700} gutterBottom sx={{ color: '#1e293b' }}>
          {t('support.stillNeedHelp')}
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b', mb: 2 }}>
          {t('support.supportHereForYou')}
        </Typography>
        <Button
          variant="contained"
          startIcon={<SupportAgent />}
          onClick={() => onContact('chat')}
          sx={{
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 2,
            px: 4,
          }}
        >
          {t('support.contactSupport')}
        </Button>
      </Card>
    </Box>
  );
}
